export * from './register.component';

